var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { Emit } from "vue-property-decorator";
import { CaseOperatorPageService } from '~/services/domain-service/case-operator-page.service';
import LegalUrgeActionArea from '~/components/collection-execution/collection-action-area/legal-urge-action-area.vue';
import { State, namespace } from 'vuex-class';
import { PageService } from '~/utils/page.service';
import { SortService } from '~/utils/sort.service';
var CollectionExecutionModule = namespace("collection-execution");
var LegalUrgeHistory = /** @class */ (function (_super) {
    __extends(LegalUrgeHistory, _super);
    function LegalUrgeHistory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.searchModel = {
            legalHandleType: '',
            courtName: '',
        };
        _this.dialog = {
            modify: false,
        };
        _this.dataSet = [];
        _this.id = null;
        _this.row = {};
        // 由于保存使用操作id匹配，使用detail防止查看时显示按钮
        _this.operatorId = "detail";
        return _this;
    }
    Object.defineProperty(LegalUrgeHistory.prototype, "titleName", {
        get: function () {
            // return this.row.operatorId === this.userData.id ? '编辑法务行动' : '详情法务行动'
            return "详情法务行动";
        },
        enumerable: false,
        configurable: true
    });
    //重置搜索条件
    LegalUrgeHistory.prototype.resetSearchFelid = function () {
        var form = this.$refs['form'];
        form.resetForm();
    };
    //获取法务行动历史
    LegalUrgeHistory.prototype.refreshData = function () {
        var _this = this;
        this.searchModel.caseId = this.caseId;
        this.caseOperatorPageService
            .queryCaseLegalRecord(this.searchModel, this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    LegalUrgeHistory.prototype.activated = function () {
        this.refreshData();
    };
    LegalUrgeHistory.prototype.onClickDetail = function (row) {
        // console.log(id, id.operatorId, this.userData)
        // this.id = row.id;
        // this.row = row
        // this.dialog.modify = true;
        // 打开法务行动界面,只打开一个tab 界面
        this.$router.openNewTab({ path: '/legally-collection-manage/legal-urge-action-flow', query: { id: row.id, operatorId: row.operatorId } }, "_record");
    };
    LegalUrgeHistory.prototype.disposeCase = function (row) {
        return row.id;
    };
    LegalUrgeHistory.prototype.formatterRegisterResult = function (row) {
        switch (row.isRegister) {
            case 'YES':
                return "是" + " (" + row.indexNumber + ")";
            case 'NO':
                return "否";
        }
    };
    LegalUrgeHistory.prototype.formatterExecuteResult = function (row) {
        switch (row.isExecute) {
            case 'YES':
                return "是" + " (" + row.executeNumber + ")";
            case 'NO':
                return "否";
        }
    };
    __decorate([
        Dependencies(PageService)
    ], LegalUrgeHistory.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], LegalUrgeHistory.prototype, "sortService", void 0);
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], LegalUrgeHistory.prototype, "caseOperatorPageService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], LegalUrgeHistory.prototype, "caseId", void 0);
    __decorate([
        State
    ], LegalUrgeHistory.prototype, "userData", void 0);
    __decorate([
        Emit("disposeCase")
    ], LegalUrgeHistory.prototype, "disposeCase", null);
    LegalUrgeHistory = __decorate([
        Component({
            components: {
                LegalUrgeActionArea: LegalUrgeActionArea
            },
        })
    ], LegalUrgeHistory);
    return LegalUrgeHistory;
}(Vue));
export default LegalUrgeHistory;
